import React from 'react';
import * as classes from './blogCard.module.css';
import getDate from '../../../../../utils/getDate';
import getReadingTime from '../../../../../utils/getReadingTime';

function truncate(str, number_of_words) {
  return str.split(' ').splice(0, number_of_words).join(' ');
}

export default function BlogCard({ blog }) {
  let blogDate = getDate(blog.date);

  return (
    <div className={classes.card}>
      <a href={blog.uri} className={classes.image_link}>
        <div className={classes.category_tag}>
          <p className={classes.category_text}>
            {blog.categories.nodes[0].name}
          </p>
        </div>
        <img
          alt={blog?.featuredImage?.node?.altText || blog.slug}
          src={
            blog?.featuredImage?.node?.mediaItemUrl ||
            'https://www.zomato.com/blog/wp-content/uploads/2021/07/cover-future-1024x674.png'
          }
          className={`${classes.image} animate`}
        />
      </a>
      <div className={`${classes.content} ${classes.padding_zero}`}>
        <div className={`text-font-family ${classes.blog_date}`}>
          <span style={{ fontWeight: 'bold' }}>{blog.author.node.name}</span>
          {` | ${blogDate} | `}
          <span>{getReadingTime(blog.content)}</span>
        </div>
        <a
          href={blog.uri}
          className={`text-font-family ${classes.blog_title} ${classes.content_space}`}
        >
          {blog.title}
        </a>
        <div
          dangerouslySetInnerHTML={{ __html: truncate(blog.excerpt, 50) }}
          className={`text-font-family ${classes.blog_content} ${classes.content_space}`}
        />
      </div>
    </div>
  );
}
